
import { SelectItem } from '../types';

export const sortSelectedItems = (valueItems: SelectItem[] = [], locale: string): SelectItem[] =>
  [...valueItems].sort((a, b) => a?.description?.localeCompare(b?.description, locale));
